import Vue from 'vue'

type State<T> = { loading: boolean, data?: T }

export function usePromise<T> (cmd: () => Promise<T>): State<T> {
  const state = { loading: false, data: undefined }
  const comp =  Vue.prototype
  comp.$set(state, 'loading', true)
  cmd()
    .then((result) => {
      comp.$set(state, 'data', result)
      comp.$set(state, 'loading', false)
    })
    .catch((error) => {
      comp.$set(state, 'loading', false)
      throw error
    })

  return state
}

export function useFormAction<T = any> (cmd: () => Promise<T>): State<T> {
  const state = { loading: false, data: undefined }
  if (state.loading) return state

  const comp =  Vue.prototype
  comp.$set(state, 'loading', true)
  cmd()
    .then((result) => {
      comp.$set(state, 'data', result)
      comp.$set(state, 'loading', false)
    })
    .catch((error) => {
      comp.$set(state, 'loading', false)
      throw error
    })

  return state
}
